export const PORKER_PRODUCT_CODES = {
  PORKER: '10',
  WHOLEPIG: '10',
  WHOLE_PIG: '10',

  TRUNK: '119',
  HAUNCH: '118',
  LEGS: '55',
  LEG: '55',
  SADDLE: '98',
  MIDDLES: '98',
  FOREQUARTER: '45'
}

export const PORKER_PRODUCT_DESCRIPTIONS = {
  PORKER: 'Porker',
  WHOLEPIG: 'Porker',
  WHOLE_PIG: 'Porker',

  TRUNK: 'Trunk',
  HAUNCH: 'Haunch',
  LEGS: 'Legs',
  LEG: 'Legs',
  SADDLE: 'Saddle',
  MIDDLES: 'Saddle',
  FOREQUARTER: 'Forequarter'
}
